import { GRAPHIC_HEIGHT } from 'helpers/constants'
import { styled } from '@mui/material/styles'

export const DividerLine = styled('div')<any>(({ isLongType }) => ({
  borderTop: '1px solid #858585',
  position: 'absolute',
  top: GRAPHIC_HEIGHT / 2,
  width: isLongType ? '100%' : '78px',
  zIndex: 2,
}))

export const DateLabel = styled('span')<any>({
  fontFamily: 'Zen Kaku Gothic Antique',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  color: '#525252',
})

export const ResponderName = styled('span')<any>({
  fontFamily: 'Quicksand',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  color: '#525252',
})

export const ResponderRelation = styled('span')<any>({
  fontFamily: 'Quicksand',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  color: '#8C8C8C',
})
